import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";
import {useQueryUserPage, UserPageVO} from "@/service/user.s";
import {ViewMember} from "@/pages/Member/ViewMember";
import Chip from "@mui/material/Chip";
import {AuthButtonVO} from "@/service/menu.s";
import {AuditMember} from "@/pages/Member/AuditMember";

export const MemberListPage = () => {
    const {
        mutate: userPageMutate,
        data: userPageData,
        isPending: userPagePending,
    } = useQueryUserPage()
    const {role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<UserPageVO>[] = [
        {
            field: "username",
            headerName: "名称",
            flex: 0.4
        },
        {
            field: "mobile",
            headerName: "联系电话",
            headerAlign: "center",
            align: "center",
            flex: 0.5
        },
        {
            field: "email",
            headerName: "邮箱",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: value => value || "-"
        },
        {
            field: "gender",
            headerName: "性别",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            valueFormatter: value => value == 1 && "男" || value == 2 && "女" || "未知"
        },
        {field: "status", headerName: "状态", renderCell: ({row}) => <Chip variant={'outlined'} size={'small'} color={'warning'} label={row.status}/>},
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    const btnCallback = async ({btn, keys, onSearch}: BtnType<UserPageVO>) => {
    }

    return (
        <ProTable<UserPageVO>
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            loading={userPagePending}
            btnCallback={btnCallback}
            renderDrawer={{view: <ViewMember/>}}
            columns={columns}
            data={userPageData?.data}
            onSearch={(params) => {
                userPageMutate({...params, roleId: "10000"});
            }}
            verifyBtns={(row: UserPageVO, btns: AuthButtonVO[]) => {
                return btns.map((btn) => {
                        if (btn.alias == 'audit') {
                            return {...btn, disabled: row.statusId == 2, maxWidth: 'xs', body: <AuditMember/>}
                        }
                        return btn
                    }
                )
            }
            }
            code={"member"}
        />
    );
};
